module.exports = {"id":"191566","name":"Park Joo Ho","rating":"73","photo":"./data/images/photos/4/191566.png","club":{"name":"Ulsan Hyundai","logo":"./data/images/clubs/UlsanHyundai.png"},"positions":["DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ParkJooHo0.json
// module id = 3369
// module chunks = 0